const fade = ["fade-down-left", 'flip-left', 'flip-right', 'zoom-in', 'zoom-in-up']
export default fade;